import React, { useState, useEffect } from "react";
import logo_hyundai from "../assets/01_Home/Icon_Hyundai-White.svg";
import Icon_Facebook from "../assets/01_Home/Icon_Facebook.svg";
import Icon_Instagram from "../assets/01_Home/Icon_Instagram.svg";
import Icon_Twitter from "../assets/01_Home/Icon_Twitter-X.svg";
import Icon_youtube from "../assets/01_Home/Icon_youtube.svg";
import { HomeSuscription } from "../components/conexion/home.conexion";
import { Link } from "react-router-dom";

/*eslint-disable */
declare const window: any;

const FooterLayouts: React.FC = () => {
  const [selectSection, setSelectSection] = useState("");
  const [email, setEmail] = useState("");
  const [act1, setAct1] = useState(false);
  const [act2, setAct2] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    setIsButtonDisabled(!(act1 && act2));
  }, [act1, act2]);

  const handleSubscribe = async () => {
    if (!email) {
      alert("Por favor, ingresa tu correo electrónico.");
      return;
    }

    try {
      HomeSuscription({
        data: {
          email,
        },
      }).then(function (res: any) {
        alert("¡Suscripción exitosa!");
        setEmail("");
        setAct1(false);
        setAct2(false);
      });
    } catch (error) {
      console.error("Error al suscribirse:", error);
      alert(
        "Hubo un error al intentar suscribirte. Por favor, inténtalo de nuevo."
      );
    }
  };

  const handlesendFooterDataLayer = (main: any, category: any) => {
    const dataLayerEvent: any = {
      event: "footer_click",
      comp_page: {
        main_category: main,
        selected_category: category,
      },
    };

    if (window.dataLayer) {
      window.dataLayer.push(dataLayerEvent);
    }
  };

  return (
    <div className="footer-layout">
      <div className="logo-footer-layout">
        <img src={logo_hyundai} alt="Hyundai Logo" />
      </div>
      
      <div className="content-footer-layout">
        {/* SECCIÓN IZQUIERDA - LEGALES */}
        <div
          className={`left-content-footer-layout ${
            selectSection === "left" ? "active" : ""
          }`}
        >
          {/* H3 - Título de la sección Legales */}
          <h3
            className="legal-txt-left-content-footer-layout"
            onClick={() =>
              setSelectSection(selectSection !== "left" ? "left" : "")
            }
          >
            Legales
          </h3>
          
          {/* Los enlaces se mantienen igual */}
          <Link
            to={"/terminos-condiciones"}
            className="legal-page-left-content-footer-layout"
            onClick={() =>
              handlesendFooterDataLayer("Legales", "Términos y condiciones")
            }
          >
            Términos y condiciones
          </Link>
          <Link
            to={"/terminos-reservas-online"}
            className="legal-page-left-content-footer-layout"
            onClick={() =>
              handlesendFooterDataLayer("Legales", "Términos Reservas Online")
            }
          >
            Términos Reservas Online
          </Link>
          <Link
            to={"/politica-pagina"}
            className="legal-page-left-content-footer-layout"
            onClick={() =>
              handlesendFooterDataLayer("Legales", "Políticas de la página")
            }
          >
            Políticas de la página
          </Link>
          <Link
            to={"/avisos-privacidad"}
            className="legal-page-left-content-footer-layout"
            onClick={() =>
              handlesendFooterDataLayer("Legales", "Avisos de privacidad")
            }
          >
            Avisos de privacidad
          </Link>
          <Link
            to={"/politica-proteccion-datos"}
            className="legal-page-left-content-footer-layout"
            onClick={() =>
              handlesendFooterDataLayer(
                "Legales",
                "Política de protección de datos"
              )
            }
          >
            Política de protección de datos
          </Link>
          <Link
            to={"/politica-calidad"}
            className="legal-page-left-content-footer-layout"
            onClick={() =>
              handlesendFooterDataLayer("Legales", "Política de calidad")
            }
          >
            Política de calidad
          </Link>
          <Link
            to={"/politica-cookies"}
            className="legal-page-left-content-footer-layout"
            onClick={() =>
              handlesendFooterDataLayer("Legales", "Política de Cookies")
            }
          >
            Política de Cookies
          </Link>
        </div>

        {/* SECCIÓN CENTRAL - DESCUBRE HYUNDAI */}
        <div
          className={`center-content-footer-layout ${
            selectSection === "center" ? "active" : ""
          }`}
        >
          {/* H3 - Título de la sección Descubre Hyundai */}
          <h3
            className="legal-txt-center-content-footer-layout"
            onClick={() =>
              setSelectSection(selectSection !== "center" ? "center" : "")
            }
          >
            Descubre Hyundai
          </h3>
          
          {/* Los enlaces se mantienen igual */}
          <Link
            to={"/quienes-somos"}
            className="legal-page-center-content-footer-layout"
            onClick={() =>
              handlesendFooterDataLayer("Descubre Hyundai", "Sobre nosotros")
            }
          >
            Sobre nosotros
          </Link>
          <Link
            to={"/noticias"}
            className="legal-page-center-content-footer-layout"
            onClick={() =>
              handlesendFooterDataLayer("Descubre Hyundai", "Últimas noticias")
            }
          >
            Últimas noticias
          </Link>
          <a
            href="https://umbraint.com/hyundai/interactive-car-studio/"
            target="_blank"
            rel="noopener noreferrer"
            className="legal-page-center-content-footer-layout"
            onClick={() =>
              handlesendFooterDataLayer(
                "Descubre Hyundai",
                "Experiencia interactiva 360°"
              )
            }
          >
            Experiencia interactiva 360°
          </a>
          <Link
            to={"/"}
            className="legal-page-center-content-footer-layout"
            onClick={() =>
              handlesendFooterDataLayer("Descubre Hyundai", "Hyundai Colombia")
            }
          >
            Hyundai Colombia
          </Link>
          
          <div className="socialmedia-center-content-footer-layout">
            <a
              href="https://www.youtube.com/channel/UCVZ1VGb5kmd-Om47wqFdjdA"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                handlesendFooterDataLayer("Descubre Hyundai", "Youtube")
              }
            >
              <img src={Icon_youtube} alt="YouTube" />
            </a>
            <a
              href="https://www.facebook.com/HyundaiColombia/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                handlesendFooterDataLayer("Descubre Hyundai", "Facebook")
              }
            >
              <img src={Icon_Facebook} alt="Facebook" />
            </a>
            <a
              href="https://x.com/HyundaiColombia"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                handlesendFooterDataLayer("Descubre Hyundai", "Twitter")
              }
            >
              <img src={Icon_Twitter} alt="Twitter" />
            </a>
            <a
              href="https://www.instagram.com/hyundai_col/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                handlesendFooterDataLayer("Descubre Hyundai", "Instagram")
              }
            >
              <img src={Icon_Instagram} alt="Instagram" />
            </a>
          </div>
        </div>

        {/* SECCIÓN DERECHA - SUSCRIPCIÓN */}
        <div
          className={`right-content-footer-layout ${
            selectSection === "right" ? "active" : ""
          }`}
        >
          {/* H3 - Título de la sección Suscripción */}
          <h3
            className="legal-txt-right-content-footer-layout"
            onClick={() =>
              setSelectSection(selectSection !== "right" ? "right" : "")
            }
          >
            ¡Suscríbete y recibe las últimas novedades!
          </h3>
          
          {/* Los elementos del formulario se mantienen igual */}
          <div className="label-right-content-footer-layout">
            Tu correo electrónico
          </div>
          
          <div className="accion-right-content-footer-layout">
            <input
              type="text"
              placeholder="Escribe tu correo electrónico"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div
              className={`subscribe-button ${
                isButtonDisabled ? "disabled" : ""
              }`}
              onClick={handleSubscribe}
              style={{
                pointerEvents: isButtonDisabled ? "none" : "auto",
                opacity: isButtonDisabled ? 0.5 : 1,
              }}
            >
              Suscribirme
            </div>
          </div>
          
          <div className="politicas-internal-accion-right-content-footer-layout">
            <input
              type="checkbox"
              checked={act1}
              onChange={(e) => setAct1(e.target.checked)}
            />
            <label htmlFor="">
              Acepto política de datos, términos y condiciones.
            </label>
          </div>
          
          <div className="politicas-internal-accion-right-content-footer-layout">
            <div>
              <input
                type="checkbox"
                checked={act2}
                onChange={(e) => setAct2(e.target.checked)}
              />
            </div>
            <label htmlFor="">
              Autorizo la transferencia y transmisión de mis datos <br /> para
              las finalidades de publicidad a las compañías de su grupo.
            </label>
          </div>
          
          <div className="text-politicas-internal-accion-right-content-footer-layout">
            <Link to="/avisos-privacidad">Política de privacidad.</Link>
          </div>
        </div>
      </div>
      
      {/* Texto de derechos de autor - se mantiene como div */}
      <div className="derechos-footer-layout">
        2024 Hyundai Motor Company Colombia. Todos los derechos reservados
      </div>
    </div>
  );
};

export default FooterLayouts;